import type { QueryParams } from "../../../../common/types";

/**
 * Returns pathname for reliable comparisons (excluding query params).
 * @param urlOrPath URL string
 * @returns pathname
 */
export const getPathname = (urlOrPath: string): string => {
	const url = new URL(urlOrPath, window.location.origin);
	return url.pathname;
};

/**
 * Compares two URLs by their pathnames
 * @param a URL string
 * @param b URL string
 * @returns true if the pathnames are the same, false otherwise
 */
export const isSamePathname = (a: string, b: string): boolean => {
	try {
		return getPathname(a) === getPathname(b);
	} catch {
		return false;
	}
};

/**
 * Omits the jql parameter from the QueryParams object
 * @param params QueryParams object
 * @returns QueryParams object with the jql parameter omitted
 */
export const omitJqlParam = (params: QueryParams | undefined): QueryParams => {
	const { jql: _jql, ...restQueryParams } = params ?? {};
	return restQueryParams;
};
